"use client";

import { useEffect } from "react";
import { withPostHog, loadObservability } from "@/shared/lib/observability/sinks";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // posthog-js loads lazily after first paint. The root layout just crashed, so
    // don't wait for idle — pull the SDK in now. withPostHog queues this report and
    // replays it the moment the SDK arrives.
    void loadObservability();
    withPostHog((posthog) =>
      posthog.capture("$exception", {
        $exception_message: error.message,
        $exception_type: error.name,
        $exception_source: "global-error",
        digest: error.digest,
      })
    );
  }, [error]);

  return (
    <html>
      <body>
        <div style={{ padding: "2rem", textAlign: "center", fontFamily: "sans-serif" }}>
          <h2>Something went wrong</h2>
          <p style={{ color: "#666", marginBottom: "1rem" }}>
            An unexpected error occurred. The team has been notified.
          </p>
          <button
            onClick={reset}
            style={{
              padding: "0.5rem 1.5rem",
              borderRadius: "0.5rem",
              border: "1px solid #ccc",
              cursor: "pointer",
              background: "#fff",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
